<template>
    <div class="grid-item">
      <div class="white">{{ label }}</div>
      <template v-if="isOneLine">
        <input :value="value" class="input-field" :type="format" :ref="id" @keyup="setValue" @click="setValue"/>
      </template>
      <template v-else>
        <textarea :value="value" class="input-field" :type="format" :ref="id" @keyup="setValue" @click="setValue" rows="1" cols="60" name="description"></textarea>
      </template>
    </div>
</template>

<script>
export default {
  props: ["label", "format", "id", "value", "isOneLine"],
  data: () => {
    return {};
  },
  methods: {
    setValue() {
      this.$emit("input_value", this.$refs[this.id].value);
    },
  },
};
</script>

<style scoped>
.grid-item {
  display: flex;
  flex-direction: column;
}

.input-field {
  border-radius: 12px;
  padding: 15px 30px 15px 30px;
  border-color: rgb(255, 255, 255);
  border-width: 1px;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.1);
}

input {
  border-width: 3px !important;
  /* color: transparent !important; */
  background-color: white !important;
  border-style: none !important;
}

input:focus {
  outline: none !important;
  border-color: greenyellow !important;
  border-width: 3px !important;
}

.white{
  color:white;
}
</style>
